import * as z from "../../../framework";
import { PopUp } from "../../../framework/components/components/popUp";
import UserDashboards from "./userDashboards";
import view from "./userDashboardsPopUp.view";

export default class UserDashboardsPopUp extends PopUp {

    userDashboards: UserDashboards;
    refreshPageOnExit: boolean;

    constructor() {
        super(view, {
            screenName: "manageUsersDashboards"
        });

        let me = this;

        this.popUpArgs = {
            width: 800,
            scrollable: true,
            removeButtons: false
        };

        me.userDashboards = new UserDashboards();
        me.refreshPageOnExit = false;
    }

    initialize(args) {
        let me = this,
            userId = z.user.loginData.UserId;

        me.userDashboards.init({
            userId: userId,
            screen: me,
            screenId: args.screenId,
            setRefreshPageOnExit: function (refresh: boolean) {
                me.refreshPageOnExit = refresh;
            }
        });

        me.userDashboards.setUsersDashboards(userId, function () {
            me.get("#SPDashboardsGrid").data("me").refresh();
        });
    }

    bindEvents() {
        let me = this,
            refreshFunction = function () {
                if (me.refreshPageOnExit) {

                    z.controls.popUp({
                        id: "RefreshPageWarning",
                        title: z.ll("RefreshWarningHeader"),
                        keepContentBox: true,
                        guts: z.ll("RefreshWarningMessage"),
                        width: 600,
                        buttons: [
                            {
                                name: "Refresh",
                                clickEvent: function () {
                                    location.reload();
                                }
                            }
                        ]
                    });

                    const fiveSecondsInMilliseconds = 5000;
                    setTimeout(function () {
                        location.reload();
                    }, fiveSecondsInMilliseconds);
                }
            };

        $(`#${me.view.id}`).closest(".k-window").find(".k-i-close").closest("a").tie("click", function (e) {
            e.preventDefault();
            me.window.close();
            refreshFunction();
        });

        me.get("#Close").tie("click", function (e) {
            e.preventDefault();
            me.window.close();
            refreshFunction();
        });

        z.bindLocalizedLanguage({
            container: me.getContainer()
        });

        me.get("#EmployeeDashboardPane .pane-header").remove();
        me.get("#EmployeeDashboardPane").addClass("pane-in-popup");
    }

}
